import GatewayService from '../../GatewayService.js';
var feedback = new GatewayService('feedbacktwo');

var getSkills = function getSkills() {
  return feedback.get("rubric/skill");
};

var saveRubricScore = function saveRubricScore(userKey, unitKey, cardstackKey, rubricKey, value) {
  var params = {
    userBusinessKey: userKey,
    unitBusinessKey: unitKey,
    cardstackBusinessKey: cardstackKey,
    rubricBusinessKey: rubricKey
  };
  return feedback.post('rubricScore', value, {
    params: params,
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveAllRubricScores = function saveAllRubricScores(userKey, unitKey, cardstackKey, rubrics) {
  return Promise.all(rubrics.map(function (rubric) {
    return saveRubricScore(userKey, unitKey, cardstackKey, rubric.rubricKey, rubric.value);
  }));
};

var fetchRubricScores = function fetchRubricScores(userKey, cardstackKey) {
  return feedback.get("rubricScore/".concat(userKey, "/cardstack/").concat(cardstackKey));
};

export default {
  getSkills: getSkills,
  saveRubricScore: saveRubricScore,
  saveAllRubricScores: saveAllRubricScores,
  fetchRubricScores: fetchRubricScores
};